
import React, {Component} from "react";
import style from "./style.scss";
import {Avatar, Dropdown, Menu} from "antd";
import {FlatIcon} from "../Icon";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import signOut from '../../../utils/signOut';


class CurrentUserDropDownMenu extends Component {

    handleLogOut = async () => {
        signOut();
    };

    menu = () => (
        <Menu className={style.currentUserDropDownMenu} width={300}>
            <Menu.Item key="0">
                <div className={style.userInfo}>
                    <Avatar size={80} src={require('../../../Assets/users/empty_avatar.jpg')} alt=""/>
                    <div className={style.content}>
                        <div className={style.name}>{this.props.user.userDemographics.name}</div>
                        <div className={style.username}>{this.props.user.userDemographics.email}</div>
                    </div>
                </div>
            </Menu.Item>

            <Menu.Item key="3"
                onClick={ () => this.handleLogOut() }
            >
                <FlatIcon icon={'exit'}/> Logout
            </Menu.Item>
        </Menu>
    );

    render() {
        return (
            <Dropdown placement={'bottomRight'} className={style.currentUserDropDownMenu} overlay={this.menu()}
                      trigger={['click']}>
                <a className="ant-dropdown-link" href="">
                    <Avatar src={'https://via.placeholder.com/50'} alt=""/>
                    <span className={style.dropDownUserFullName}>{this.props.user.userDemographics.name}</span>
                </a>
            </Dropdown>
        )
    }
}

CurrentUserDropDownMenu.propTypes = {
    user: PropTypes.object.isRequired
  };

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(
 mapStateToProps
)(CurrentUserDropDownMenu);



// WEBPACK FOOTER //
// ./src/Components/Theme/CurrentUserDropDownMenu/index.js